const PREFIX = 'LENDER_ORCHESTRATION';

const key = (field: string, value: string, suffix = '') => `${PREFIX}_${field}_${value.toUpperCase()}${suffix}`;

// i18n keys: LENDER_ORCHESTRATION_<FIELD>_<VALUE>[_SUFFIX]
export class OrchestrationLabelsMap {
  static strategy(value: string, suffix: '' | '_SUMMARY' | '_DESCRIPTION' = ''): string {
    return key('STRATEGY', value, suffix);
  }

  static mode(value: string, suffix: '' | '_TITLE' | '_SUMMARY' | '_DESCRIPTION' = ''): string {
    return key('MODE', value, suffix);
  }

  static stopCondition(value: string, suffix: '' | '_TITLE' | '_SUMMARY' | '_DESCRIPTION' = ''): string {
    return key('STOP', value, suffix);
  }

  static chooseStrategy(value: string, suffix: '' | '_SUMMARY' | '_DESCRIPTION' = ''): string {
    return key('CHOOSE', value, suffix);
  }
}
